(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react-dom/server"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define("ReactAsyncActions", ["react-dom/server", "react"], factory);
	else if(typeof exports === 'object')
		exports["ReactAsyncActions"] = factory(require("react-dom/server"), require("react"));
	else
		root["ReactAsyncActions"] = factory(root["react-dom/server"], root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asyncActions = __webpack_require__(2);

Object.defineProperty(exports, 'asyncActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_asyncActions).default;
  }
});

var _fireAsyncActions = __webpack_require__(3);

Object.defineProperty(exports, 'fireAsyncActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fireAsyncActions).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (stateToActions) {
  return function (MyComponent) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.asyncRender = Boolean(_this.context.addDep), _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(_class, [{
        key: 'fireActions',
        value: function fireActions() {
          var actions = stateToActions(this.props);
          return Promise.all(actions.filter(function (val) {
            return val && val.then;
          }));
        }
      }, {
        key: 'componentWillMount',


        // ONLY run on server when AsyncProvider is used
        value: function componentWillMount() {
          var _this2 = this;

          if (this.asyncRender) {
            this.context.addDep({
              callActions: function callActions() {
                return _this2.fireActions();
              },
              factoryRef: stateToActions
            });
          }
        }

        // Doesn't run on server

      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.fireActions();
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(MyComponent, this.props);
        }
      }]);

      return _class;
    }(_react.Component), _class.contextTypes = {
      addDep: _react.PropTypes.func
    }, _class.displayname = 'FireActions', _temp2;
  };
};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (element, customOptions) {
  var _class, _temp;

  var deps = [];
  var defaultOptions = {
    maxPasses: Infinity
  };
  var options = _extends({}, defaultOptions, customOptions);

  var AsyncProvider = (_temp = _class = function (_React$Component) {
    _inherits(AsyncProvider, _React$Component);

    function AsyncProvider() {
      _classCallCheck(this, AsyncProvider);

      return _possibleConstructorReturn(this, (AsyncProvider.__proto__ || Object.getPrototypeOf(AsyncProvider)).apply(this, arguments));
    }

    _createClass(AsyncProvider, [{
      key: 'addDep',
      value: function addDep(_ref) {
        var callActions = _ref.callActions;
        var factoryRef = _ref.factoryRef;

        var promisesResolved = deps.map(function (p) {
          return p.factoryRef;
        }).find(function (ref) {
          return ref === factoryRef;
        });

        if (!promisesResolved) {
          deps.push({
            promise: callActions(),
            factoryRef: factoryRef
          });
        }
      }
    }, {
      key: 'getChildContext',
      value: function getChildContext() {
        var _this2 = this;

        return { addDep: function addDep(p) {
            return _this2.addDep(p);
          } };
      }
    }, {
      key: 'render',
      value: function render() {
        return this.props.children;
      }
    }]);

    return AsyncProvider;
  }(_react2.default.Component), _class.propTypes = {
    children: _react2.default.PropTypes.node
  }, _class.childContextTypes = {
    addDep: _react2.default.PropTypes.func
  }, _temp);


  var elem = _react2.default.createElement(
    AsyncProvider,
    null,
    element
  );

  var renderPass = function renderPass() {
    var prevPromisesCount = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
    var passCount = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];

    var results = {
      passes: passCount
    };

    if (passCount >= options.maxPasses) {
      return Promise.resolve(results);
    } else {
      var _ret = function () {
        (0, _server.renderToStaticMarkup)(elem);
        var currPromisesCount = deps.length;
        var promise = Promise.all(deps.map(function (p) {
          return p.promise;
        }));

        if (currPromisesCount > prevPromisesCount) {
          return {
            v: promise.then(function () {
              return renderPass(currPromisesCount, passCount + 1);
            })
          };
        } else {
          return {
            v: promise.then(function () {
              return results;
            })
          };
        }
      }();

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
  };

  return renderPass();
};

/***/ },
/* 4 */
/***/ function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }
/******/ ])
});
;
//# sourceMappingURL=react-async-actions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-async-actions/dist/react-async-actions.js
// module id = 172
// module chunks = 1